import { compose, __, not } from 'ramda'
import * as actions from 'actions/feature/simulation'
import { getIn, setIn } from 'utils/immutable/index'

export default {
  [actions.populateDefaultSimulationValues]: setSimulationDefaults,
  [actions.updateSimulatedValue]: updateSimulatedValue,
  [actions.resetSimulatedValue]: resetSimulatedValue,
  [actions.updateSimulationEvaluations]: updateSimulationEvaluations,
  [actions.pauseSimulateMode]: togglePlayPause,
  [actions.playSimulateMode]: togglePlayPause,
  [actions.enterSimulateMode]: enterSimulateMode,
  [actions.updateSimulationSpeed]: updateSimulationSpeed,
  [actions.updateSimulatedOutputCurrent]: updateSimulatedOutputCurrent,
  [actions.openSimulatedFuse]: openSimulatedFuse,
  [actions.resetSimulatedFuse]: resetSimulatedFuse,
  FUSE_IGNITION_RESET: resetSimulatedFuses,
  [actions.TIME_REMAINING_VIRTUAL_FUSE_RESET]:
    updateTimeRemainingVirtualFuseReset,
}

function updateSimulationSpeed(state, { speed }) {
  return state.setIn(['simulations', 'meta', 'speed'], speed)
}

function enterSimulateMode(state) {
  return state
    .setIn(['simulations', 'meta', 'playing'], true)
    .setIn(['simulations', 'meta', 'speed'], 1)
}

function updateSimulationEvaluations(state, { values }) {
  return state.mergeDeepIn(['simulations', 'values'], values)
}

function setSimulationDefaults(state, { values }) {
  return state.setIn(['simulations', 'values'], values)
}

function updateSimulatedValue(state, { uri, value }) {
  return state.setIn(['simulations', 'values', uri, 'current'], value)
}

function resetSimulatedValue(state, { conditionUri }) {
  return compose(
    setIn(['simulations', 'values', conditionUri, 'current'], __, state),
    getIn(['simulations', 'values', conditionUri, 'default'])
  )(state)
}

function togglePlayPause(state, action) {
  return state.setIn(
    ['simulations', 'meta', 'playing'],
    not(state.getIn(['simulations', 'meta', 'playing']))
  )
}

function updateSimulatedOutputCurrent(state, { outputId, currentAmps }) {
  return state.setIn(
    ['simulations', 'values', outputId, 'currentAmps'],
    currentAmps
  )
}

function openSimulatedFuse(state, { outputId, fuseType }) {
  return state
    .setIn(['simulations', 'values', outputId, 'fuseOpen'], true)
    .setIn(['simulations', 'values', outputId, 'outputting'], false)
}

function resetSimulatedFuse(state, { outputId, retries = undefined }) {
  return state
    .setIn(['simulations', 'values', outputId, 'fuseOpen'], false)
    .setIn(['simulations', 'values', outputId, 'retries'], retries)
    .setIn(['simulations', 'values', outputId, 'outputting'], true)
}

function resetSimulatedFuses(state) {
  const outputs = state.getIn(['currentFeature', 'outputs'])

  const simulatedFuses = state
    .getIn(['simulations', 'values'])
    .filter((simulation, outputId) => {
      return (
        simulation.get('fuseOpen') &&
        outputs.getIn([outputId, 'resetType']) === 'IGNITION'
      )
    })
  if (simulatedFuses.size === 0) return state
  return state.mergeDeepIn(
    ['simulations', 'values'],
    simulatedFuses
      .map((simulation, outputId) =>
        resetSimulatedFuse(simulation, { outputId }).getIn([
          'simulations',
          'values',
          outputId,
        ])
      )
      .toJS()
  )
}

function updateTimeRemainingVirtualFuseReset(
  state,
  { outputId, timeRemainingMs }
) {
  return state.setIn(
    ['simulations', 'values', outputId, 'timeRemainingMs'],
    timeRemainingMs
  )
}
